import info from '@/assets/icons/info_blue.svg'
import { AppAvailabilityStatus } from "@/constants/TCS/TCS";
import { AppComponentClassname } from "@/constants/application/application";
import { workflowActions } from '@/redux/slice/workflowSlice';
import { App } from "@/types/applications";
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export const AppComponent = ({
  app,
  navigatePath
}: {
  app: App,
  navigatePath: string
}) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const getClassNameWithStatus = (status: AppAvailabilityStatus) => {
    const appName = status === AppAvailabilityStatus.ACTIVE
      ? AppComponentClassname.ACTIVE_APP_NAME
      : AppComponentClassname.COMING_SOON_APP_NAME
    const cardComponent = status === AppAvailabilityStatus.ACTIVE
      ? AppComponentClassname.ACTIVE
      : AppComponentClassname.COMING_SOON

    return {
      appName,
      cardComponent
    }
  }

  const onSourceClick = (
    status: AppAvailabilityStatus,
  ) => {
    if (status === AppAvailabilityStatus.ACTIVE) {
      if (navigatePath.includes('workflows')) {
        dispatch(workflowActions.addStep({
          id: app.id,
          action: '',
          subject: '',
          credentialId: '',
          order: 0,
          filters: [],
          options: [],
          requiredOptions: []
        }))
        navigate(navigatePath)
      } else {
        navigate(`${navigatePath}/${app.id}`)
      }
    }
  }

  return (
    <div
      key={app.id}
      className={getClassNameWithStatus(app.status as AppAvailabilityStatus).cardComponent}
      onClick={() => onSourceClick(app.status as AppAvailabilityStatus)}
    >
      <img
        src={app.logo}
        className="h-10 flex flex-row items-center justify-center"
      />
      <p className={getClassNameWithStatus(app.status as AppAvailabilityStatus).appName}>
        {app.displayName}
      </p>
      {app.status === AppAvailabilityStatus.COMING_SOON && (
        <div className="flex items-center">
          <img src={info} className="mr-2" />
          <p className="uppercase font-semibold text-xs leading-3 text-accent tracking-wider">
            Coming Soon
          </p>
        </div>
      )}
    </div>
  )
}
